export const isSPLL = (licenseId: string): boolean => {
  return /^[A-Z]\d{6}$/.test(licenseId);
};
